import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';

import { concatUrl } from 'modules/shared/utils';
import { FolderTypeValues } from 'modules/shared/models';
import { SubRouterProps } from 'modules/shared/types';
import { Switch, PrivateRoute, NotFound } from 'modules/shared/components';

import { routes } from '../../config';
import { LoginPage } from '../../pages';

import { RedirectToPersonalSpace } from './components';
import { PersonalSpaceLayout } from '../../layouts';

export const Router: React.FC<SubRouterProps> = (props: SubRouterProps) => {
    const { navigationTree } = props;

    const loginPath = concatUrl([navigationTree.path, '/login']);
    return (
        <Switch>
            <PrivateRoute
                path={concatUrl([navigationTree.path, routes[FolderTypeValues.CUSTOMER].path])}
                authenticationPath={loginPath}
                allowedFolderType={FolderTypeValues.CUSTOMER}
                render={subProps => {
                    const EspaceClientModule = loadable(() =>
                        import(/* webpackChunkName: "espace-client" */ '../../modules/espace-client/espace-client'),
                    );
                    return <EspaceClientModule {...props} path={subProps.match.path} />;
                }}
            />
            <PrivateRoute
                path={concatUrl([navigationTree.path, routes[FolderTypeValues.PROSPECT].path])}
                authenticationPath={loginPath}
                allowedFolderType={FolderTypeValues.PROSPECT}
                render={subProps => {
                    const EspaceProspectModule = loadable(() =>
                        import(
                            /* webpackChunkName: "espace-prospect" */ '../../modules/espace-prospect/espace-prospect'
                        ),
                    );
                    return <EspaceProspectModule {...props} path={subProps.match.path} />;
                }}
            />
            <Route
                exact
                path={loginPath}
                render={() => (
                    <PersonalSpaceLayout>
                        <LoginPage />
                    </PersonalSpaceLayout>
                )}
            />
            <PrivateRoute
                authenticationPath={loginPath}
                exact
                path={navigationTree.path}
                render={() => {
                    return <RedirectToPersonalSpace basePath={navigationTree.path} />;
                }}
            />
            <Route component={NotFound} />
        </Switch>
    );
};
